document.querySelector('.toggleUnit').addEventListener('click', function () {
  const tables = document.querySelectorAll('#mguide table, #mguideshorts table');
  const isConverted = this.dataset.converted === 'true';

  tables.forEach(table => {
    table.querySelectorAll('td').forEach(td => {
      const text = td.textContent.trim();
      const num = parseFloat(text);

      if (!isNaN(num)) {
        if (!td.dataset.original) td.dataset.original = num;

        let value = parseFloat(td.dataset.original);
        if (!isConverted) {
          value = Math.round((value * 2.54) * 2) / 2;
        } else {
          value = parseFloat(td.dataset.original);
        }
        td.textContent = value;
      }

      else {
        if (!td.dataset.originalText) td.dataset.originalText = text;

        if (!isConverted) {
          td.textContent = td.dataset.originalText
            .replace(/\b(inch|inches)\b/gi, match =>
              match[0] === match[0].toUpperCase() ? "Centimeters" : "centimeters"
            );
        } else {
          td.textContent = td.dataset.originalText;
        }
      }
    });
  });

  this.dataset.converted = !isConverted;
});